// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ExploitOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ExploitOffIcon" ref={forwardedRef} {...props}>
      <path d="M5.233 17.01a5.5 5.5 0 0 0 6.805-6.805l-1.292 1.292a4.002 4.002 0 0 1-4.221 4.22z" />
      <path d="M9.333 8.667a4 4 0 0 0-3.617-.808A3.98 3.98 0 0 0 3.53 9.353a3.99 3.99 0 0 0-.641 3.405 4 4 0 0 0 .807 1.547l-1.063 1.063a5.5 5.5 0 0 1-1.193-2.222 5.49 5.49 0 0 1 .88-4.68A5.48 5.48 0 0 1 5.329 6.41a5.48 5.48 0 0 1 3.798.352L10.18 5.77a2.75 2.75 0 0 1 2.637-.642L12.86 5.14z" />
      <path d="M16.174 1.826 14.4 3.6l-.412-.488 1.91-1.612z" />
      <path d="m16.236 6.006.9-.9 1.601-.01L18.735 6.6l-2.5.016z" />
      <path d="m15.988 7.714 1.61 1.91-1.146.967-1.611-1.91z" />
      <path d="M1 17 16.556 1.444l1.061 1.06L2.061 18.061z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ExploitOffIcon = /* @__PURE__ */ Object.assign(
  ExploitOffIconComponent,
  { displayName: 'ExploitOffIcon' },
);
